import { Grid, Typography } from "@mui/material";
import type { CardTransactionStatus } from "Infrastructure/Api/Api";
import { CardStatusFilterDropdown } from "Components/CardTransactions/CardTransactionFilters/CardStatusFilterDropdown";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  value?: CardTransactionStatus;
  onChange: (value: CardTransactionStatus | undefined) => void;
};

export const CardStatusFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.Status)}
      </Typography>
      <CardStatusFilterDropdown value={value} onChange={onChange} />
    </Grid>
  );
};
